import { Injectable } from '@angular/core';
import { Api } from '../services/api';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  constructor(public api: Api) {
  }

  getMemberAudits(membershipId) {
    let seq = this.api.get('bp/v1/getCommentsByMemberId/' + membershipId, true);
    return seq;
  }

  getPurchaseHistory(postData) {
    let seq = this.api.post('bp/v1/getPurchaseHistory', postData, true);
    return seq;
  }

}
